import type { UploadedImage } from '../../../../../../../types';
import { DiscoveryContentTypes } from '../../../../../../../constants';
import { HTMLtoJSX } from '../../../../../../../helpers';
import { ProductCard } from '../../../../productFilter/products';
import ImageTag from '../../../../../../shared/ImageTag/ImageTag';
import {
  CardAnchor,
  Image,
  Title,
  CardButton,
  TopicsList,
  Badge,
} from '../../../../productFilter/cards/components';
import s from '../RelatedSiteCard/RelatedSiteCard.module.scss';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';

export const mediaTypeMap = {
  NEWS_MEDIA: 'News Media',
  EVENT: 'Event',
  BRAND: 'Brand',
  AWARD: 'Award',
  PODCAST: 'Podcast',
  REPORT: 'Report',
};

export interface ExternalSite {
  name: string;
  description: string;
  type: keyof typeof mediaTypeMap;
  topics: string[];
  subBrands: string[];
  logo: UploadedImage;
  coverImage: UploadedImage;
  url: string;
  urlText?: string;
  contentType: DiscoveryContentTypes.EXTERNAL_SITE;
}

export interface ExternalSiteCardProps {
  data: ExternalSite;
}

export default function ExternalSiteCard(props: ExternalSiteCardProps) {
  const {
    data: { name, description, type, logo, coverImage, url, urlText },
  } = props;

  const { location } = useRootSelector(selectPageConfig);

  return (
    <CardAnchor to={url}>
      <ProductCard
        image={<Image path={coverImage?.path} />}
        topics={
          <TopicsList list={[type]}>
            {(topic) => {
              const topicType = topic as keyof typeof mediaTypeMap;

              return (
                <Badge theme="outlined" size="tiny" className={s.topic}>
                  {mediaTypeMap[topicType] || topicType}
                </Badge>
              );
            }}
          </TopicsList>
        }
        title={<Title size="extraSmall">{name}</Title>}
        description={<Badge>{HTMLtoJSX(description, location)}</Badge>}
        largeLogo={<ImageTag src={logo?.path} />}
        leftFooter={<CardButton>{urlText || 'Visit'}</CardButton>}
        showMoreBadge={<CardButton>{urlText || 'Visit'}</CardButton>}
        className={s.card}
      />
    </CardAnchor>
  );
}
